'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isOpenThreadMessage = undefined;

var _messageTypes = require('../constants/messageTypes');

var _isType = require('./isType');

var isOpenThreadMessage = exports.isOpenThreadMessage = (0, _isType.isType)(_messageTypes.OPEN_THREAD);